<template>
  <div>
    <Header
      :logo-white="false"
      :button="true"
      :background="true"
    />
    <PageHeader 
      :back= true
      title="" 
      sub-title="Veelgestelde vragen"
    />
    <div class="flex-grid">
      <div class="col col-3 border">
        <div class="col-title">
          <h4>
            <font-awesome-icon
              :icon="['far', 'folder-open']"
              :style="{ marginRight: '14px' }"
            />Waarom iSalu?
          </h4>
        </div>
        <ul>
          <li
            v-for="(faq, i) in faqData.slice(0, 6)"
            :key="i"
          >
            <font-awesome-icon
              :icon="['far', 'file-alt']"
              :style="{ marginRight: '14px' }"
            />
            <a
              href
              @click.stop.prevent="openModal(i + 1)"
            >
              {{
                faq.question
              }}
            </a>
          </li>
        </ul>
        <div class="box">
          <button class="btn-blue btn-block btn-small text-center">
            <router-link :to="{name: 'PageZelfVerkopen'}">
              Zelf Verkopen
            </router-link>
          </button>
        </div>
      </div>
      <div class="col col-3 border">
        <div class="col-title">
          <h4>
            <font-awesome-icon
              :icon="['far', 'folder-open']"
              :style="{ marginRight: '14px' }"
            />Hoe verkoop ik mijn woning via iSalu?
          </h4>
        </div>
        <ul>
          <li
            v-for="(faq, i) in faqData.slice(6, 11)"
            :key="i"
          >
            <font-awesome-icon
              :icon="['far', 'file-alt']"
              :style="{ marginRight: '14px' }"
            />
            <a
              href
              @click.stop.prevent="openModal(i + 7)"
            >
              {{
                faq.question
              }}
            </a>
          </li>
        </ul>
        <div class="box">
          <button class="btn-blue btn-block btn-small text-center">
            <router-link :to="{name: 'Registreren'}">
              Inschrijven
            </router-link>
          </button>
        </div>
      </div>
      <div class="col col-3 border">
        <div class="col-title">
          <h4>
            <font-awesome-icon
              :icon="['far', 'folder-open']"
              :style="{ marginRight: '14px' }"
            />Hoe koop ik een woning via iSalu?
          </h4>    
        </div>
        <ul>
          <li
            v-for="(faq, i) in faqData.slice(11, 16)"
            :key="i"
          >
            <font-awesome-icon
              :icon="['far', 'file-alt']"
              :style="{ marginRight: '14px' }"
            />
            <a
              href
              @click.stop.prevent="openModal(i + 12)"
            >
              {{
                faq.question
              }}
            </a>
          </li>
        </ul>
        <div class="box">
          <button class="btn-blue btn-block btn-small text-center">
            <router-link :to="{name: 'Zoek huis'}">
              Woning gezien?
            </router-link>
          </button>
        </div>
      </div>
    </div>
    <Modal
      v-if="stateModal && currentQA"
      :question="currentQA.question"
      :answer="currentQA.answer"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Modal from "@/components/ComponentFAQModal";
import faqData from "@/publicfaq.json";
import PageHeader from "@/components/ComponentPageHeader";
import Header from "@/components/ComponentHeader";

export default {
  name: "PublicFAQ",
  components: {
    Modal,
    PageHeader,
    Header
  },
  data() {
    return {
      selectedQuestion: 0,
      faqData
    };
  },
  computed: {
    ...mapState({
      stateModal: state => state.openModal
    }),
    currentQA() {
      if (this.selectedQuestion && this.selectedQuestion > 0) {
        return this.faqData[this.selectedQuestion - 1];
      }
      return false;
    }
  },
  methods: {
    openModal(i) {
      this.$store.dispatch("toggleModal", !this.stateModal);
      this.selectedQuestion = i;
    }
  }
};
</script>

<style scoped>
h4 {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 14px;
  border-bottom: 1px solid #e7e7e7;
}

font-awesome-icon {
  padding-right: 10px;
}

.content-image {
  position: absolute;
  bottom: -10px;
  right: 0;
}
.flex-grid {
  margin-top: 60px;
}
.col {
  padding: 24px;
}

.col-3 {
  flex: 1;
}

li {
  display: flex;
}

@media (min-width: 240px) and (max-width: 720px) {
  .col-3 {
    flex-basis: 96%;
    margin: 2% 4%;
  }
}

li {
  margin-bottom: 8px;
}
</style>
